export default __webpack_public_path__ + "static/P2P_Cam_Live_03-ca1772b7b7934bb0777bfa93dafe11e3.webp";